"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionValidationMiddleware = void 0;
const AbstractAuthorizerMiddleware_1 = require("../Middlewares/AbstractAuthorizerMiddleware");
const SportradarResourceName_1 = require("../SportradarResource/SportradarResourceName");
const debugLog_1 = __importDefault(require("../Utils/debugLog"));
class ActionValidationMiddleware extends AbstractAuthorizerMiddleware_1.AbstractAuthorizerMiddleware {
    async validateAction(action) {
        const srn = this.computeSportradarResourceName(action);
        (0, debugLog_1.default)('ActionValidationMiddleware.validateAction', { action, srn: srn.toString() });
        const isValid = await this.enforcer.enforce(action.userId, action.actionName, srn.toString());
        (0, debugLog_1.default)('ActionValidationMiddleware.validateAction', isValid ? 'ALLOW' : 'DENY');
        return isValid;
    }
    // noinspection JSMethodCanBeStatic
    computeSportradarResourceName(action) {
        return new SportradarResourceName_1.SportradarResourceName(action.domainName, action.resourceType, action.resourceId || '', action.ownerId, action.holdingId, action.businessEntityId);
    }
}
exports.ActionValidationMiddleware = ActionValidationMiddleware;
//# sourceMappingURL=ActionValidationMiddleware.js.map